import * as z from "zod";

export const ReturnChatSchema = z.object({ threadId: z.string().nullish() });
